import _ from "lodash";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { parseCurrency } from "../../../util/formatters";
import { snakifyKeys } from "../../../util/helpers";
import { NonCoveredPricingForm } from "./NonCoveredPricingForm";

export const EditNonCoveredPricingModal = ({ nonCoveredPricing, onEdit, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleEdit = async (values) => {
    const newValues = _.cloneDeep(values);
    setError(null);
    try {
      if (values.priceCents) {
        newValues.priceCents = parseCurrency(newValues.priceCents) * 100;
      }

      const res = await api.patch(`/admin/non_covered_pricings/${nonCoveredPricing.id}`, {
        non_covered_pricing: snakifyKeys(newValues),
      });

      if (onEdit) {
        onEdit(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  if (!nonCoveredPricing) {
    return null;
  }

  const initialValues = {
    ...nonCoveredPricing,
    priceCents: nonCoveredPricing.priceCents / 100,
    cptCodeId: nonCoveredPricing.cptCode.id,
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Non-Covered Pricing for CPT Code</ModalHeader>

        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleEdit} initialValues={initialValues}>
            {(props) => <NonCoveredPricingForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
